import {
  IResearchIntakeRequest,
  IResearchIntakeResponse,
} from "features/Research/types";
import { apiClient } from "lib/apiClient";

export const createResearchIntake = async (
  request: IResearchIntakeRequest
): Promise<IResearchIntakeResponse> => {
  const response = await apiClient.post("/research/intake", request);

  return response.data;
};
